import React from 'react'
import { useNavigate } from 'react-router-dom';

const DevotionalBreadCrumb = (props) => {

       const {contentsbreadCrumb,type,breadCrumb,subBreadCrumb}=props;
       const pcategory = subBreadCrumb?.[0]?.pcategory || subBreadCrumb?.[1]?.pcategory || null
       const purl = subBreadCrumb?.[0]?.purl || subBreadCrumb?.[1]?.purl || null
      
        const scategory = subBreadCrumb?.[0]?.scategory || subBreadCrumb?.[1]?.scategory || null
       const surl = subBreadCrumb?.[0]?.surl || subBreadCrumb?.[1]?.surl || null

       const navigate = useNavigate()

        function isTelugu(text) {
                 const teluguRegex = /[\u0C00-\u0C7F]/;
                 return teluguRegex.test(text);
             }   

  return (
   <div className='devotional-breadcrumb'>
          <p ><span onClick={() => navigate('/')} className='bread-pointer'>Home</span> {' '} <span className='arrow'> {" » "}</span>
          
          
           {type && type === 'Video Gallery' ?
           <span style={{color:'#900909' }} onClick={() => navigate('/videos/bhaktivideos.html')}  className='bread-pointer' >{type}</span> : ''}  
           {type && type === 'Video Gallery' ? <span className='arrow'> {" » "}</span> : ''}
           
           {pcategory && purl && <span style={{color:'#900909' }} onClick={() => navigate(purl ? purl.substring(purl.indexOf('/devotional')+11 ) : '/')}  className='bread-pointer' >{pcategory}</span>  }
           {pcategory && purl  ? <span className='arrow'> {" » "}</span> : ''} 

           
            {scategory && surl && <span style={{color:'#900909' }} onClick={() => navigate(surl ? surl.substring(surl.indexOf('/devotional')+11 ) : '/')}  className='bread-pointer' >{scategory}</span>  }
            {scategory && surl  ? <span className='arrow'> {" » "}</span> : ''} 
           
           
            <span style={{color:'#0c0a65' }} >{breadCrumb ? breadCrumb : ''}</span></p>
    </div>
  )
}

export default DevotionalBreadCrumb;